
  /* jshint ignore:start */
(function($) {
  /* jshint ignore:end */
